// @flow
import type { CallState, OperatorsState } from './reducer';
import { IN_PROCESS } from './reducer';
import { MOUNT_POINT } from './constants';


export const getCallingState: (state: Object) => CallState = (state) => state[MOUNT_POINT];
export const getCallState: (state: Object) => CallState = (state) => state[MOUNT_POINT].call;
export const getRegistered: (state: Object) => CallState = (state) => state[MOUNT_POINT].registered;
export const getCallee: (state: Object) => CallState = (state) => state[MOUNT_POINT].call?.callee;

export const getHeld: (state: Object) => boolean = (state) => state[MOUNT_POINT].call?.held;
export const getMuted: (state: Object) => boolean = (state) => state[MOUNT_POINT].call?.muted;
export const callInProcess: (state: Object) => boolean = (state) => (
        state[MOUNT_POINT].call?.status === IN_PROCESS
);
export const getOperatorsState: (state: Object) => OperatorsState = (state) => state[MOUNT_POINT].operators;
export const getHoldPending: (state: Object) => boolean = (state: Object) => state[MOUNT_POINT].call?.holdPending;
export const getTransfer: (state: Object) => boolean = (state: Object) => state[MOUNT_POINT].call?.transfer;
export const getSessionEstablished: (state: Object) => boolean = (state: Object) => (
    state[MOUNT_POINT].call?.sessionEstablished
);

export const getDTMFRequests: (state: Object) => string[] = (state: Object) => state[MOUNT_POINT].call?.dtmfRequests;
export const getSentDTMFRequests: (state: Object) => number[] = (
    state: Object,
) => state[MOUNT_POINT].call?.dtmfRequestsSent;

export const getCooldownState: (state: Object) => CallState = (state) => state[MOUNT_POINT].cooldownState;
